import { NavConfig } from 'src/@types/menu';
import { RolePermissions } from 'src/config';
import { FeatureFlags } from 'src/@types/types';
import { IconifyMenuIconEnum } from 'src/@types/icon';
import IconifyIcon from 'src/components/icons/IconifyIcon';

export const getNavConfig = (params: {
  featureFlags?: FeatureFlags;
  disabledCompanyData?: boolean;
  disabledBoxOffice?: boolean;
}) => {
  const { featureFlags, disabledCompanyData, disabledBoxOffice } = params;

  const navConfig: NavConfig[] = [
    {
      subheader: 'menu.event.label',
      items: [
        {
          title: 'menu.event.event.label',
          path: '/dashboard/event',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.CALENDAR} />,
          children: [
            {
              title: 'menu.event.event.create',
              path: '/dashboard/event/add',
              value: RolePermissions.EVENT_CREATE,
            },
            {
              title: 'menu.event.event.list',
              path: '/dashboard/event/list',
              value: RolePermissions.EVENT_LIST,
            },
            {
              title: 'menu.event.event.limit',
              path: '/dashboard/event/limit-management',
              value: RolePermissions.EVENT_LIMIT_MANAGEMENT,
            },
            {
              title: 'menu.event.event.history',
              path: '/dashboard/event/history',
              value: RolePermissions.EVENT_HISTORY,
            },
          ],
        },
        {
          title: 'menu.event.statistics.label',
          path: '/dashboard/statistics',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.STATISTICS} />,
          children: [
            {
              title: 'menu.event.statistics.sales',
              path: '/dashboard/statistics/sales',
              value: RolePermissions.STATISTICS_SALES,
            },
            {
              title: 'menu.event.statistics.report',
              path: '/dashboard/statistics/report',
              value: RolePermissions.STATISTICS_REPORT,
            },
            {
              title: 'menu.event.statistics.customizedStatistics',
              path: '/dashboard/statistics/customized-statistics',
              value: RolePermissions.STATISTICS_CUSTOMIZED,
            },
          ],
        },
        {
          title: 'menu.event.marketing.label',
          path: '/dashboard/marketing',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.MARKETING} />,
          disabledFeature: !featureFlags?.coupons?.enabled,
          children: [
            {
              title: 'menu.event.marketing.coupon',
              path: '/dashboard/marketing/coupon',
              value: RolePermissions.MARKETING_COUPON,
            },
          ],
        },
        {
          title: 'menu.event.finance.label',
          path: '/dashboard/finance',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.FINANCE} />,
          children: [
            {
              title: 'menu.event.finance.settlement',
              path: '/dashboard/finance/settlement',
              value: RolePermissions.SETTLEMENT,
            },
          ],
        },
        {
          title: 'menu.event.guestTicket.label',
          path: '/dashboard/event/guest',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.TICKET} />,
          disabledFeature: !featureFlags?.guest_invitation?.enabled,
          children: [
            {
              title: 'menu.event.guestTicket.invite',
              path: '/dashboard/event/guest/invite',
              value: RolePermissions.GUESTS_INVITE,
            },
            {
              title: 'menu.event.guestTicket.upload',
              path: '/dashboard/event/guest/upload',
              value: RolePermissions.GUESTS_INVITE,
              disabledFeature: !featureFlags?.guests_upload?.enabled,
            },
            {
              title: 'menu.event.guestTicket.generate',
              path: '/dashboard/event/guest/generate-tickets',
              value: RolePermissions.GUESTS_INVITE,
              disabledFeature: !featureFlags?.generate_guest_tickets?.enabled,
            },
            {
              title: 'menu.event.guestTicket.list',
              path: '/dashboard/event/guest/list',
              value: RolePermissions.GUESTS_LIST,
            },
            {
              title: 'menu.event.guestTicket.limit',
              path: '/dashboard/event/guest/limit-management/users',
              value: RolePermissions.GUESTS_LIMIT_MANAGEMENT,
            },
            {
              title: 'menu.event.guestTicket.settings',
              path: '/dashboard/event/guest/settings',
              value: RolePermissions.GUESTS_SETTINGS,
            },
          ],
        },
        {
          title: 'menu.event.boxoffice.label',
          path: '/dashboard/box-office',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.SALE} />,
          children: [
            {
              title: 'menu.event.boxoffice.events',
              path: '/dashboard/box-office/events',
              value: RolePermissions.BOXOFFICE_FUNCTIONS,
            },
            {
              title: 'menu.event.boxoffice.orders',
              path: '/dashboard/box-office/orders',
              value: RolePermissions.BOXOFFICE_FUNCTIONS,
              disabledFeature: !featureFlags?.box_office?.enabled || disabledBoxOffice,
            },
            {
              title: 'menu.event.boxoffice.dailyClosing',
              path: '/dashboard/box-office/daily-closing',
              value: RolePermissions.BOXOFFICE_FUNCTIONS,
              disabledFeature: !featureFlags?.box_office?.enabled || disabledBoxOffice,
            },
            {
              title: 'menu.event.boxoffice.settings',
              path: '/dashboard/box-office/settings',
              value: RolePermissions.BOXOFFICE_SETTINGS,
            },
          ],
        },
        {
          title: 'menu.event.export.label',
          path: '/dashboard/export',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.DOWNLOAD} />,
          disabledFeature: !featureFlags?.export?.enabled,
        },
        {
          title: 'menu.event.search.label',
          path: '/dashboard/search',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.SEARCH} />,
          value: RolePermissions.TICKET_SEARCH,
        },
        // {
        //   title: 'menu.event.newsletter',
        //   path: '',
        //   icon: ICONS.newsletter,
        //   value: PagePermissionEnum.NEWSLETTER,
        // },
      ],
    },
    // {
    //   subheader: 'menu.entry.label',
    //   items: [
    //     {
    //       title: 'menu.entry.entrySystem.label',
    //       path: '',
    //       icon: ICONS.entry,
    //       children: [
    //         { title: 'menu.entry.entrySystem.list', path: '', value: PagePermissionEnum.ENTRY_LIST },
    //         { title: 'menu.entry.entrySystem.edit', path: '', value: PagePermissionEnum.ENTRY_EDIT },
    //         {
    //           title: 'menu.entry.entrySystem.delete',
    //           path: '',
    //           value: PagePermissionEnum.ENTRY_DELETE,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      subheader: 'menu.ntak.label',
      items: [
        {
          title: 'menu.ntak.attraction.label',
          path: '/dashboard/ntak/attraction',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.NTAK} />,
          children: [
            {
              title: 'menu.ntak.attraction.registration',
              path: '/dashboard/ntak/attraction/register',
              value: RolePermissions.NTAK_EDIT_LIST,
            },
            {
              title: 'menu.ntak.attraction.list',
              path: '/dashboard/ntak/attraction/list',
              value: RolePermissions.NTAK_EDIT_LIST,
            },
          ],
        },
      ],
    },
    {
      subheader: 'menu.accountSettings.label',
      items: [
        {
          title: 'menu.accountSettings.account.label',
          path: '/dashboard/account',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.PERSON} />,
          children: [
            { title: 'menu.accountSettings.account.profile', path: '/dashboard/account/profile' },
            {
              title: 'menu.accountSettings.account.companyData',
              path: '/dashboard/account/company-data',
              disabledFeature: disabledCompanyData,
            },
            // {
            //   title: 'menu.accountSettings.account.termsAndConditions',
            //   path: '/dashboard/account/terms-and-conditions',
            // },
          ],
        },
        {
          title: 'menu.accountSettings.invitedUsers.label',
          path: '/dashboard/invited-user',
          icon: <IconifyIcon icon={IconifyMenuIconEnum.GROUP} />,
          children: [
            {
              title: 'menu.accountSettings.invitedUsers.invite',
              path: '/dashboard/invited-user/invite',
              value: RolePermissions.USER_INVITE,
            },
            {
              title: 'menu.accountSettings.invitedUsers.list',
              path: '/dashboard/invited-user/list',
              value: RolePermissions.USER_LIST,
            },
            {
              title: 'menu.accountSettings.invitedUsers.history',
              path: '/dashboard/history',
              value: RolePermissions.USER_HISTORY,
            },
          ],
        },
      ],
    },
  ];

  return navConfig;
};
